import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/api/client";
import {
  getInnstillingerOptions,
  getInnstillingerQueryKey,
  postInnstillingerMutation,
} from "@/api/generated/@tanstack/react-query.gen";

export const useInnstillingerData = (
  organizationNumber: number | undefined,
) => {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    ...getInnstillingerOptions({
      path: {
        // biome-ignore lint/style/noNonNullAssertion: Query disabled if null
        organisasjonsNummer: organizationNumber!,
      },
      client: httpClient,
    }),
    enabled: organizationNumber != null,
  });

  const mutation = useMutation({
    ...postInnstillingerMutation({
      client: httpClient,
    }),
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: getInnstillingerQueryKey({
          path: {
            organisasjonsNummer:
              res.innstillinger.varmeSelskapOrganisasjonsnummer,
          },
          client: httpClient,
        }),
      });
    },
  });

  return {
    innstillinger: data?.innstillinger,
    isLoading,
    error,
    mutate: {
      mutateInnstillingerAsync: mutation.mutateAsync,
      isPending: mutation.isPending,
    },
  };
};
